// package imports
import React from 'react';

// CSS imports
import './FlexSystem.css';

type Props = {
  children: React.ReactNode;
  itemPadding?: number;
  className?: string;
};

const FlexSystem: React.FC<Props> = ({
  children,
  itemPadding,
  className,
}: Props) => {
  return (
    <div
      className={`FlexSystem ${className ? className : ''} ${
        itemPadding === 1
          ? 'flex-padding-1'
          : itemPadding === 2
          ? 'flex-padding-2'
          : itemPadding === 3
          ? 'flex-padding-3'
          : itemPadding === 4
          ? 'flex-padding-4'
          : itemPadding === 5
          ? 'flex-padding-5'
          : itemPadding === 6
          ? 'flex-padding-6'
          : itemPadding === 7
          ? 'flex-padding-7'
          : itemPadding === 8
          ? 'flex-padding-8'
          : itemPadding === 9
          ? 'flex-padding-9'
          : itemPadding === 10
          ? 'flex-padding-10'
          : itemPadding === 11
          ? 'flex-padding-11'
          : itemPadding === 12
          ? 'flex-padding-12'
          : itemPadding === 13
          ? 'flex-padding-13'
          : itemPadding === 14
          ? 'flex-padding-14'
          : itemPadding === 15
          ? 'flex-padding-15'
          : itemPadding === 16
          ? 'flex-padding-16'
          : itemPadding === 17
          ? 'flex-padding-17'
          : itemPadding === 18
          ? 'flex-padding-18'
          : itemPadding === 19
          ? 'flex-padding-19'
          : itemPadding === 20
          ? 'flex-padding-20'
          : ''
      }`}
      style={{ margin: itemPadding ? itemPadding * -1 + 'px' : '-10px' }}
    >
      {children ? children : null}
      {/* {children.map((child) =>
        React.cloneElement(child, {
          style: {
            ...child.props.style,
            padding: '10px !important',
          },
        })
      )} */}
    </div>
  );
};

export default FlexSystem;
